import { Injectable } from '@angular/core';
import { O365Licenses } from '@app/common/o365-licenses';
import { UserService } from '@app/services/user.service';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LicenseService {

  constructor(private userService: UserService) { }

  private hasUser365License$: Observable<boolean>;

  hasUserAny365License(): Observable<boolean> {
    if (!this.hasUser365License$) {
      this.hasUser365License$ = this.userService.getMyDetailsFromMsGraph(true)
        .pipe(
          map(user => user.assignedLicenses.some(license =>
            license.skuId === O365Licenses.MICROSOFT_365_BUSINESS
            || license.skuId === O365Licenses.MICROSOFT_365_E3
            || license.skuId === O365Licenses.Microsoft_365_E5
            || license.skuId === O365Licenses.Microsoft_365_F1
            || license.skuId === O365Licenses.OFFICE_365_BUSINESS
            || license.skuId === O365Licenses.O365_BUSINESS_ESSENTIALS
            || license.skuId === O365Licenses.O365_BUSINESS_PREMIUM
            || license.skuId === O365Licenses.OFFICE_365_ENTERPRISE_E1
            || license.skuId === O365Licenses.OFFICE_365_ENTERPRISE_E2
            || license.skuId === O365Licenses.OFFICE_365_ENTERPRISE_E3
            || license.skuId === O365Licenses.OFFICE_365_ENTERPRISE_E3
            || license.skuId === O365Licenses.OFFICE_365_ENTERPRISE_E4
            || license.skuId === O365Licenses.OFFICE_365_ENTERPRISE_E5
            || license.skuId === O365Licenses.OFFICE_365_ENTERPRISE_E5_WITHOUT_AUDIO_CONFERENCING
            || license.skuId === O365Licenses.OFFICE_365_F1
            || license.skuId === O365Licenses.OFFICE_365_MIDSIZE_BUSINESS
            || license.skuId === O365Licenses.OFFICE_365_PROPLUS
            || license.skuId === O365Licenses.OFFICE_365_SMALL_BUSINESS
            || license.skuId === O365Licenses.OFFICE_365_SMALL_BUSINESS_PREMIUM)
          ),
          shareReplay({ bufferSize: 1, refCount: true })
        );
    }
    return this.hasUser365License$;
  }

  hasUserLicense(skuIds: Array<string>): Observable<boolean> {
    return this.userService.getMyDetailsFromMsGraph()
      .pipe(
        map(user => {
          return user.assignedLicenses.some(license => skuIds.includes(license.skuId)) || user.assignedPlans.some(plan => plan.capabilityStatus === 'Enabled' && plan.service === 'PowerBI');
        }),
        shareReplay({ bufferSize: 1, refCount: true })
      );
  }
}
